export default "__VITE_ASSET__XkVRxvrb__"